import { graphql } from 'msw';

import { constants } from '@trqk/utils';

import { hasValidToken } from '../utils';

export const getTrqkUserSubscriptionSettings = graphql.query<
    GetTrqkUserSubscriptionSettingsQuery,
    GetTrqkUserSubscriptionSettingsQueryVariables
>('getTrqkUserSubscriptionSettings', (req, res, ctx) => {
    if (hasValidToken(req, 'publisher')) {
        return res(
            ctx.data({
                getTrqkUser: {
                    id: constants.TEST_USERS.PUBLISHER.ID,
                    subscription_active: true,
                    subscription_detection_tracks: 1,
                    subscription_expiration_date: '2030-11-11T19:23:00.000Z',
                    subscription_id: 'subscription-id',
                    subscription_plan_type:
                        'CHARGEBEE_PLAN_PUBLISHER' as ChargebeePlanId,
                    subscription_royalty_capacity: 1,
                },
            }),
        );
    }

    return res();
});
